import { createAsyncActionType } from './index';

export const GET_PARTNERS = createAsyncActionType('partner', 'GET_PARTNERS');
export const GET_PARTNER_DETAIL = createAsyncActionType(
  'partner',
  'GET_PARTNER_DETAIL'
);
